<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Project/POA/components/Bitacora/Grid'
    export default {
        components: {
            Grid,
        }
    }
</script>